<template>
    <v-popper ref="colorPicker" position="bottomEnd" :auto-hide="false" :offset="4">
        <div slot="trigger">
            <div class="field field-popper-select position-relative" :class="{'is-error': isInvalid}">
                <div class="color-swatch cursor-pointer" :style="swatchStyle" @click="openPicker"></div>
                <r-input
                    :label="label"
                    v-popper-trigger
                    :value="color"
                    @input="updateValue"
                    left-label="#"/>
            </div>
        </div>
        <div class="popover" style="min-width: auto" slot="content">
            <chrome
                :value="colors"
                :disable-alpha="true"
                @input="updateHex"/>
        </div>
    </v-popper>
</template>

<script>
    import vPopper from '@/components/v-popper';
    import {Chrome} from 'vue-color';

    export default {
        name: 'color-input',
        props: {
            label: String,
            validate: [Object, Boolean],
            value: {
                type: String,
                default: `FFFFFF`,
            },
        },
        components: {Chrome, vPopper},
        computed: {
            color() {
                return this.value.toUpperCase();
            },
            colors() {
                return {
                    hex: `#${this.color}`,
                };
            },
            isInvalid() {
                if (typeof this.validate === 'boolean') {
                    return !this.validate;
                }
                return this.validate.$invalid;
            },
            swatchStyle() {
                return `background-color: #${this.color}`;
            },
        },
        methods: {
            openPicker() {
                this.$refs.colorPicker.$emit('request-popper-show');
            },
            updateValue(value) {
                this.$emit('input', value.replace('#', ''));
            },
            updateHex({hex = '#ffffff'}) {
                this.$emit('input', hex.replace('#', ''));
            },
        },
    };
</script>
